import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AccountService, TestService } from "../../../api/services";
import { GlobalApp } from "../../../tools/global";
import { LoginLocal } from "../../../api/models";
import { ForgotPasswordService } from "../../../api/services/forgot-password.service";
import { SubscriptionService } from "../../../api/services";

@Component({
  selector: "account-login",
  templateUrl: "./account-login.component.html",
})
export class AccountLoginComponent implements OnInit, OnDestroy {
  public emailAddress: string = "";
  public password: string = "";
  public errorMessage: string = "";
  public forgotPasswordFlag: boolean = false;
  public resendFlag: boolean = false;
  public loggingIn: boolean = false;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private globalApp: GlobalApp,
    private forgotPasswordService: ForgotPasswordService,
    public subscriptionService: SubscriptionService
  ) { }

  ngOnInit() {
    this.globalApp.setShowBranding(true);
  }

  ngOnDestroy() {
    this.globalApp.setShowBranding(false);
  }

  loginUser() {
    this.errorMessage = "";

    var loginLocalParams: LoginLocal = {
      email: this.emailAddress,
      password: this.password,
    };

    this.loggingIn = true;

    this.accountService.accountLoginLocal(loginLocalParams).subscribe(
      (result) => {
        if (result == null) {
          this.errorMessage = "Invalid Credentials";
          this.loggingIn = false;
        } else {
          if (result.loginStatus != 1) {
            this.errorMessage = result.errorMessage;

            if (result.loginStatus == -3) {
              this.resendFlag = true;
            }

            this.loggingIn = false;
          } else if ((result.loginStatus = 1)) {
            const jwtResult = JSON.parse(result.jwtToken);
            this.globalApp.logIn(
              jwtResult.id,
              jwtResult.auth_token,
              result.isAdmin,
              result.isSupportAdmin,
              this.emailAddress,
              result.lastStatus.lastInteractiveWasModified,
              result.lastStatus.lastInteractiveId,
              result.lastStatus.lastReportStandardTypeId,
              result.lastStatus.lastReportStandardLayoutId,
              result.lastStatus.lastReportEmbeddedTypeId,
              result.lastStatus.lastReportEmbeddedLayoutId,
              result.lastStatus.lastEditReportStandardTypeId,
              result.lastStatus.lastEditReportEmbeddedTypeId,
              result.lastStatus.lastPodLayoutInteractiveId,
              result.lastStatus.lastPodLayoutId
            );

            this.subscriptionService
              .subscriptionGetUserSubscriptionState()
              .subscribe((userState) => {
                this.globalApp.setUserState(userState);

                if (this.globalApp.returnUrl != '') {
                  var returnUrl = this.globalApp.returnUrl;
                  this.globalApp.returnUrl = '';
                  this.router.navigate([returnUrl]);
                } else {
                  this.router.navigate(["/"]);
                }

                this.loggingIn = false;
              });
          }
        }
      },
      (error) => {
        this.errorMessage = "Critical Error, Contact Support";
        this.loggingIn = false;
      }
    );
  }

  forgotPassword() {
    this.forgotPasswordFlag = true;
  }

  sendResetPassword() {
    if (this.emailAddress !== "") {
      this.forgotPasswordService
        .forgotPasswordSendForgotPasswordLink(this.emailAddress)
        .subscribe((result) => {
          this.errorMessage =
            "If your email address was found, a reset email will arrive in your inbox shortly.  If the email does not appear, check your junk folder.";
        });
    } else {
      this.errorMessage = "Email address required.";
    }
  }

  cancelResetPassword() {
    this.forgotPasswordFlag = false;
  }

  resendEmailVerification() {
    var params: LoginLocal = {
      email: this.emailAddress,
      password: "",
    };

    this.accountService
      .accountResendVerification(params)
      .subscribe((result) => {
        if (result) {
          this.errorMessage =
            "Verification email sent, make sure you check your junk folder.";
          this.resendFlag = false;
        } else {
          this.errorMessage = "Failed to resend email, please contact support.";
          this.resendFlag = false;
        }
      });
  }

  onKeyDown($event: KeyboardEvent) {
    if($event.key == "Enter") {
      this.loginUser();
    }
  }
}
